<template>
  <div>
    <div class="Category">
      <div
        class="CateWrap animated bounceInUp"
        v-for="(item) in list"
        :key="item.CategoryId"
        @click="GoCategoryList(item.CategoryId)"
      >
        <img class="CateImg" :src="item.Img | thumbnail(750,424)">
      </div>
    </div>
  </div>
</template>
<script>
// import { GetCategory } from "../apis/https.js";
export default {
  props: {
    list: {
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    GoCategoryList(id) {
      this.$emit("ClickItem", id);
    }
  }
};
</script>

<style lang="less" scoped>
.loading {
  margin: auto;
  font-size: 20px;
}
.Category {
  padding-top: 4.5px;
  .CateWrap {
    padding: 0px 4px;
    margin-bottom: 3.5px;
    overflow: hidden;
    .CateImg {
      width: 100%;
      float: left;
    }
  }
}
</style>